import React, { Component, Fragment } from 'react'
import './App.scss'
import 'react-image-lightbox/style.css' // This only needs to be imported once in your app
import './fonts/css/icons.css'
import './fonts/css/jlr.css'
import Exterior from './components/Exterior'
import Interior from './components/Interior'
import ModeSwitcher from './components/ModeSwitcher'
import ModelSwitcher from './components/ModelSwitcher'
import DiscoverButton from './components/DiscoverButton'
import Modal from './components/Modal'
import { connect } from 'react-redux'
import { hideModal, showModal } from './store/actions'
import { getLocalFilePath } from './js/getLocalFilePath'

const NODE_ENV = process.env.NODE_ENV

class App extends Component {
  state = {
    mode: 'exterior',
    model: 'convertible',
    overlay: true,
    wrapperStyle: NODE_ENV !== 'production' ?
      { paddingTop: `${(window.innerHeight / window.innerWidth) * 100}%` } : {}
  }

  // START: debug stylings, should be 16:9 for production (is embeded at that aspect ratio)
  componentDidMount () {
    if (NODE_ENV === 'production') return

    document.querySelector('.three-sixty-spinner').addEventListener('fullscreenchange', e => {
      if (window.screen.height === window.innerHeight) {
        return this.setState({
          wrapperStyle: {}
        })
      }

      this.setState({
        wrapperStyle: { paddingTop: `${(window.innerHeight / window.innerWidth) * 100}%` }
      })
    })
  }

  // END: debug stylings

  renderOverlay () {
    const { overlay } = this.state
    if (!overlay) return null

    return (
      <div
        className="three-sixty-overlay"
        onClick={() => this.setState({ overlay: false })}
        onTouchStart={() => this.setState({ overlay: false })}
      >
        <img alt='click and drag to explore icon' src={getLocalFilePath('/images/overlay-icon.svg')} />
        <p> Click and Drag to Explore the Vehicle </p>
      </div>
    )
  }

  renderMode () {
    const { mode, model } = this.state
    return (
      <div className={'three-sixty-render'}>
        <Exterior model={model} visible={mode === 'exterior'}/>
        {mode === 'interior' && <Interior model={model} showModal={this.renderModal()}/>}
      </div>
    )
  }

  renderModal () {
    return (
      <Modal
        onClose={() => {
          this.setState({ modal: false })
        }}
      />
    )
  }

  renderWarningModal () {
    return (
      <div id='three-sixty-warning-message'>
        <p>This app only works in landscape, please rotate your device.</p>
      </div>
    )
  }

  render () {
    window.$ = window.jQuery
    const { showModal, hideModal } = this.props
    const { mode, wrapperStyle } = this.state
    return (
      <div className={'three-sixty-spinner'}>
        {this.renderWarningModal()}
        <div id='three-sixty-wrapper' style={wrapperStyle}>
          {this.renderOverlay()}
          <ModeSwitcher
            onChange={mode => {
              hideModal()
              this.setState({ mode })
            }}
          />
          <DiscoverButton onClick={() => showModal('discover')}/>
          {this.renderMode()}
          {this.renderModal()}
          <ModelSwitcher
            onChange={model => {
              this.setState({ model })
            }}
            mode={mode}
          />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: type => dispatch(showModal(type)),
    hideModal: () => dispatch(hideModal())
  }
}

export default connect(
  null,
  mapDispatchToProps
)(App)
